// hooks
import { useCurrentUser } from 'hooks/index'
// types
import { IPlan } from 'types/graphql'
// utils
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/fp/map'
import pipe from 'lodash/fp/pipe'
import { isCurrentUser } from 'utils/user'
import { safeGetOr } from 'utils/fp'

export const usePlanAccess = (plan: IPlan) => {
  const user = useCurrentUser()

  const {
    permissionsFromSecurityGroups: { adminViewPrivatePlans }
  } = useCurrentUser()

  if (!plan || isEmpty(plan)) {
    return false
  }

  if (!plan.private || adminViewPrivatePlans) {
    return true
  }

  const memberPositionsIds = pipe<any, any, any>(
    safeGetOr([], 'memberPositions'),
    map('id')
  )(plan)

  const membersUsersIds = pipe<any, any, any>(
    safeGetOr([], 'memberUsers'),
    map('id')
  )(plan)

  const ids = [plan.ownedById, ...memberPositionsIds, ...membersUsersIds]

  return ids.some(id => isCurrentUser(id, user))
}
